<section>
    <div class="d-flex justify-content-between mb-3">
        <div class="heading-fs-16">Preview</div>
        <div class="preview-chip" *ngIf="lastUpdatedAt"><span class="text-muted">Last updated at:</span>
            {{lastUpdatedAt}}</div>
    </div>
    <div nz-col nzSpan="24">
        <nz-divider></nz-divider>
    </div>

    <div nz-row *ngIf="previewIframeUrl || isPreviewIframeLoading; else staticPreview">
        <div nz-col nzSpan="24" class="justify-content-center">
            <div class="live-preview-frame" [class.live-preview-frame--portrait]="isSideways">
                <!-- Turned the way the screen is, like the screenshot below: a screen mounted sideways previews sideways. -->
                <div class="live-preview-rotator" [ngClass]="'live-preview-rotator--' + (screenOrientation || 0)">
                <nz-spin [nzSpinning]="isPreviewIframeLoading" class="live-preview-spin">
                    <iframe class="live-preview-iframe"
                        *ngIf="previewIframeUrl"
                        [src]="previewIframeUrl"
                        (load)="iframeLoad.emit()"
                        (error)="iframeError.emit()"
                        [style.visibility]="isPreviewIframeLoading ? 'hidden' : 'visible'"
                        title="Live preview"
                        scrolling="no"
                        frameborder="0"></iframe>
                </nz-spin>
                </div>
                <div class="live-preview-click-overlay" *ngIf="previewIframeUrl && previewModalData"
                    (click)="openPreviewModal()"></div>
            </div>
        </div>
    </div>

    <ng-template #staticPreview>
        <div nz-row>
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="justify-content-center">
                <div [ngClass]="{'preview-display-static-container': showDefault, 'preview-display-dynamic-container': !showDefault && (screenOrientation == null || screenOrientation == 0 || screenOrientation == 180), 'preview-display-dynamic-container-rotate': !showDefault && (screenOrientation == 90 || screenOrientation == 270), 'rotate-90 ' : screenOrientation == 90,
                'rotate-180' : screenOrientation == 180, 'rotate-270' : screenOrientation == 270}">
                    <img (error)="onError.emit()" *ngIf="isImagePreview()" (click)="open(url)" [src]="url" style="object-fit: contain;"
                    [ngClass]="{'preview_img' : isImagePreview() && type !== mediaType.image && lastUpdatedAt, 'type-icon-fallback': isTypeIconFallback}" class="lightmode_img"  alt="preview-image">
                    <!-- Dev Need to add dynamic url for dark  -->
                    <img (error)="onError.emit()" *ngIf="isImagePreview()" (click)="open(url)" [src]="url" style="object-fit: contain;"
                        [ngClass]="{'preview_img' : isImagePreview() && type !== mediaType.image && lastUpdatedAt, 'type-icon-fallback': isTypeIconFallback}" class="darkmode_img"  alt="preview-image">
                    <app-pdf-viewer *ngIf="isPdfPreview()" [pdfSrc]="url" [pageChangeDuration]="pageChangeDuration" class="preview-pdf-container"></app-pdf-viewer>
                    <app-video-viewer *ngIf="isVideoPreview() && url" [source]="url" class="preview-video-container"></app-video-viewer>
                </div>
            </div>

            <!-- <div nz-col nzSpan="24" class="preview-content"
                *ngIf="!hidePreviewMessage && showDefault && noPlaylistOrBroadcast">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="mr-2"></span> Select a playlist or a
                broadcast to see a preview
            </div> -->
            <div nz-col nzSpan="24" class="preview-content"
                *ngIf="!hidePreviewMessage && showDefault && noMediaInAddedPlaylist">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="mr-2"></span> Add media to your playlist to
                see a preview
            </div>
            <div nz-col nzSpan="24" class="preview-content" *ngIf="showDefault && !mediaUploaded && uploadMedia">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="mr-2"></span> Upload media to see a preview
            </div>
            <div nz-col nzSpan="24" class="preview-content" *ngIf="showDefault && !mediaExists && uploadMediaFromBroadcast">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="mr-2"></span> Select media to see a preview
            </div>
            <div nz-col nzSpan="24" class="preview-content"
                *ngIf="showDefault && !mediaUploaded  && uploadMediaFromPlaylist">
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="mr-2"></span> Select media to see a preview
            </div>
        </div>
    </ng-template>
</section>